
	import { defineComponent, ref, reactive, onMounted, toRefs } from 'vue'
	import { message } from 'ant-design-vue'
	import { RuleObject } from 'ant-design-vue/es/form/interface'
	import { getCallLine } from '../request'
	import multiply from '@/common/functions/multiply'
	import toast from '@/common/functions/toast'
	import SelectLine from '../../business/components/SelectLine.vue'
	import PackageItem from '../../business/components/PackageItem.vue'
	import SeatItem from '../../business/components/SeatItem.vue'

	export default defineComponent({
		components: {
			SelectLine,
			PackageItem,
			SeatItem
		},
		props: {
			appForm: {
				type: Object,
				default: () => {}
			},
			detail: {
				type: Object,
				default: () => {}
			}
		},
		emits: ['close', 'success'],
		setup(props, { emit }) {
			const { appForm, detail } = toRefs(props)
			const visible = ref(true)
			const checkedVoice = ref(false)
			const checkedDoubleCall = ref(false)
			const checkedSip = ref(false)

			const form = reactive({
				// 短信营销
				messageInfo: {
					unitPrice: 0.05,
					signature: []
				},
				// 人工外呼
				outCall: {
					supplierType: 0,
					callLine: '',
					callbackHost: '',
					zhuqueNum: '',
					//网络电话线路num
					callAccountNum: '',
					//语音线路num
					webCallAccountNum: '',
					//双呼回显线路num
					doubleCallAccountNum: '',
					accountInfo: {
						accountName: '',
						password: ''
					},
					callFeeInfo: {
						extenFee: 10, //坐席月租
						airtimeFee: 0.15, //电话单价
						numberFee: 10, //号码月租
						numberCount: 20,
						callPackageFeeInfo: {
							money: '',
							timeMinute: ''
						},
						callExtenInfo: {
							extenCount: 0,
							extens: []
						}
					},
					webCallAccountInfo: {
						accountName: '',
						password: '',
						serviceNo: '',
						serviceNoVoice: ''
					},
					webCallFeeInfo: {
						airtimeFee: 0.15, //电话单价
						concurrencyFee: 0, //并发费
						concurrencyCount: 10,
						numberFee: 10, //号码月租
						numberCount: 20
					},
					// 双呼账户
					doubleCallAccountInfo: {
						accountName: '',
						password: '',
						accountId: '',
						pbx: '',
						secretkey: '',
						host: ''
					},
					// 双呼费用
					doubleCallFeeInfo: {
						extenFee: 10,
						airtimeFee: 0.15,
						numberFee: 10,
						numberCount: 20,
						callPackageFeeInfo: {
							money: '',
							timeMinute: ''
						},
						callExtenInfo: {
							extenCount: 0,
							extens: []
						}
					}
				}
			})
			const callLines = ref([])

			const formRef = ref()

			// 校验短信单价
			const validateMessageUnitPrice = (rule: RuleObject, value: string) => {
				if (appForm.value.code === 'duanxin' && !form.messageInfo.unitPrice) {
					return Promise.reject('请输入短信单价')
				} else {
					return Promise.resolve()
				}
			}
			// 校验短信签名
			const validateMessageSignature = (rule: RuleObject, value: string) => {
				if (appForm.value.code === 'duanxin' && !form.messageInfo.signature.length) {
					return Promise.reject('请输入短信签名')
				} else {
					return Promise.resolve()
				}
			}
			const rules = {
				'messageInfo.unitPrice': [
					{
						required: true,
						validator: validateMessageUnitPrice
					}
				],
				'messageInfo.signature': [
					{
						required: true,
						validator: validateMessageSignature
					}
				]
			}

			const configJson = ref('')
			const close = () => {
				emit('close')
			}
			const ok = () => {
				if (
					form.outCall.supplierType === 1 &&
					!checkedVoice.value &&
					!checkedDoubleCall.value &&
					!checkedSip.value
				) {
					return toast('请选择外呼模式')
				}
				formRef.value.validate().then(() => {
					if (appForm.value.code === 'duanxin') {
						// 短信营销
						let messageInfoParams = {
							unitPrice: multiply(form.messageInfo.unitPrice || 0, 100),
							signature: form.messageInfo.signature.map((item: any) => {
								return { name: item }
							})
						}
						configJson.value = JSON.stringify(messageInfoParams)
					} else if (appForm.value.code === 'rengongwaihu') {
						// 人工外呼
						let outCallParams
						if ([0, 2].includes(form.outCall.supplierType)) {
							outCallParams = {
								supplierType: form.outCall.supplierType,
								callLine: form.outCall.callLine,
								callbackHost: form.outCall.callbackHost,
								wayType: 'local',
								doubleCallAccountNum: form.outCall.zhuqueNum,
								doubleCallFeeInfo: {
									extenFee: multiply(form.outCall.doubleCallFeeInfo.extenFee || 0, 100),
									airtimeFee: multiply(form.outCall.doubleCallFeeInfo.airtimeFee || 0, 100),
									numberFee: multiply(form.outCall.doubleCallFeeInfo.numberFee || 0, 100),
									numberCount: form.outCall.doubleCallFeeInfo.numberCount || 0,
									callPackageFeeInfo: {
										money: multiply(
											+form.outCall.doubleCallFeeInfo.callPackageFeeInfo.money || 0,
											100
										),
										timeMinute: form.outCall.doubleCallFeeInfo.callPackageFeeInfo.timeMinute || 0
									}
								},
								doubleCallAccountInfo: form.outCall.doubleCallAccountInfo
							}
						}
						if (form.outCall.supplierType === 1) {
							outCallParams = {
								supplierType: 1,
								callbackHost: form.outCall.callbackHost,
								callAccountNum: form.outCall.callAccountNum,
								//语音线路num
								webCallAccountNum: form.outCall.webCallAccountNum,
								//双呼回显线路num
								doubleCallAccountNum: form.outCall.doubleCallAccountNum
							}
							Object.assign(outCallParams, {
								accountInfo: form.outCall.accountInfo,
								callFeeInfo: {
									extenFee: multiply(form.outCall.callFeeInfo.extenFee || 0, 100),
									airtimeFee: multiply(form.outCall.callFeeInfo.airtimeFee || 0, 100),
									numberFee: multiply(form.outCall.callFeeInfo.numberFee || 0, 100),
									numberCount: form.outCall.callFeeInfo.numberCount || 0,
									callPackageFeeInfo: {
										money: multiply(+form.outCall.callFeeInfo.callPackageFeeInfo.money || 0, 100),
										timeMinute: form.outCall.callFeeInfo.callPackageFeeInfo.timeMinute || 0
									},
									callExtenInfo: form.outCall.callFeeInfo.callExtenInfo
								},
								doubleCallAccountInfo: form.outCall.doubleCallAccountInfo,
								doubleCallFeeInfo: {
									extenFee: multiply(form.outCall.doubleCallFeeInfo.extenFee || 0, 100),
									airtimeFee: multiply(form.outCall.doubleCallFeeInfo.airtimeFee || 0, 100),
									numberFee: multiply(form.outCall.doubleCallFeeInfo.numberFee || 0, 100),
									numberCount: form.outCall.doubleCallFeeInfo.numberCount || 0,
									callPackageFeeInfo: {
										money: multiply(
											+form.outCall.doubleCallFeeInfo.callPackageFeeInfo.money || 0,
											100
										),
										timeMinute: form.outCall.doubleCallFeeInfo.callPackageFeeInfo.timeMinute || 0
									},
									callExtenInfo: form.outCall.doubleCallFeeInfo.callExtenInfo
								},
								webCallAccountInfo: form.outCall.webCallAccountInfo,
								webCallFeeInfo: {
									concurrencyFee: multiply(form.outCall.webCallFeeInfo.concurrencyFee || 0, 100), //并发费
									concurrencyCount: form.outCall.webCallFeeInfo.concurrencyCount || 0,
									airtimeFee: multiply(form.outCall.webCallFeeInfo.airtimeFee || 0, 100),
									numberFee: multiply(form.outCall.webCallFeeInfo.numberFee || 0, 100),
									numberCount: form.outCall.webCallFeeInfo.numberCount || 0
								}
							})
							// "wayType":""//外呼模式 local sip voice
							let ways: string[] = []
							checkedVoice.value && ways.push('voice')
							checkedDoubleCall.value && ways.push('local')
							checkedSip.value && ways.push('sip')
							Object.assign(outCallParams, {
								wayType: ways.join()
							})
						}
						configJson.value = JSON.stringify(outCallParams)
					}
					emit('success', configJson.value)
				})
			}
			const handleChange = () => {
				if (form.messageInfo.signature.length > 3) {
					message.warn('最多3个短信签名')
					form.messageInfo.signature = form.messageInfo.signature.slice(0, 3)
				}
				console.log('是否改变')
			}
			const fetchCallLine = async () => {
				try {
					const res3 = await getCallLine({ cropId: detail.value.corpId, bizId: detail.value.bizId })
					callLines.value = res3.data
				} catch (error) {}
			}
			onMounted(() => {
				fetchCallLine()
			})
			return {
				checkedVoice,
				callLines,
				visible,
				close,
				ok,
				handleChange,
				form,
				rules,
				formRef,
				checkedDoubleCall,
				checkedSip
			}
		}
	})
